import backend from "../services/backend";
import { ServerStatus as ServerStatusComponent } from "../components/ServerStatus";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { useQuery } from "@tanstack/react-query";

export default function ServerStatusPage() {
  useDocumentTitle("Server Status");

  const { data: status, isLoading: loading, error } = useQuery({
    queryKey: ["serverStatus"],
    queryFn: () => backend.getStatus().then((res) => res.data),
  });

  return (
    <ServerStatusComponent status={status ?? null} loading={loading} error={error?.message ?? null} />
  );
}
